import React from 'react';
import styled from 'styled-components';
import { theme } from '@tools/ui-utils/theme.util';

const RibbonContainer = styled.div`
  pointer-events: none;
  z-index: 999;
  width: 85px;
  height: 88px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: -3px;
`;

const Ribbon = styled.div`
  font: bold 15px sans-serif;
  text-align: center;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  position: relative;
  padding: 7px 0;
  top: 15px;
  left: -30px;
  width: 120px;
  background-color: ${theme.colors.ribbon.backgroundColor};
  color: ${theme.colors.ribbon.color};
`;

type props = {
  message: string;
};

const RibbonCorner: React.FC<React.PropsWithChildren<props>> = ({ message }) => {
  return (
    <RibbonContainer>
      <Ribbon>{message}</Ribbon>
    </RibbonContainer>
  );
};

export default RibbonCorner;
